export const pathes = {
  BASE_PATH: '/abt-ticket',
  DEFAULT: '/',
  QR_CODE: '/QR-code',
  ADD_CARD: '/add-card',
  CONVERT_TO_STUDENT_CARD: '/convert-to-student-card',
  CONVERT_TO_COLLEGIAN_CARD: '/convert-to-collegian-card',
  NEAR_STATIONS: '/near-stations',
  ACCOUNT: '/account',
  WALLET: '/wallet',
  TRANSACTIONS_LIST: '/transactions-list',
  CARD_BALANCE: '/card-balance',
  ONE_WAY_TICKET: '/one-way-ticket',
  PAY_ONE_WAY_TICKET: '/pay-one-way-ticket/:id',
  TICKET_CARD_CHARGER: '/ticket-card-charger',
  SINGLE_TICKET_DETAILS: '/single-ticket-details',
}
